import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedImports} from '@shared/shared-imports';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PaymentMethodModel} from '@app/models/payment-methods.model';
import {OrganizationRegistrationModel} from '@app/models/organizations.model';
import {SelfRegistrationModel} from '@app/models/user-registration.model';

@Component({
  selector: 'app-registration-page-3',
  templateUrl: './registration-page-3-billing.component.html',
  styleUrls: ['./registration-page-3-billing.component.scss'],
  imports: [
    SharedImports
  ]
})

export class RegistrationPage3BillingComponent implements OnInit, OnChanges {
  mainForm: FormGroup;
  ccType: string;
  visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
  mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
  amexpRegEx = /^(?:3[47][0-9]{13})$/;
  discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
  flipped: boolean = false;
  @Output() updateData = new EventEmitter<any>();
  @Input() registrationProfile: SelfRegistrationModel;
  @Output() next = new EventEmitter<any>();
  @Input() campaignId: number;
  @Input() organizationDetails: OrganizationRegistrationModel;

  constructor(private formBuilder: FormBuilder) {
    this.mainForm = this.formBuilder.group({
      fullName: new FormControl(null, [Validators.required]),
      cc: new FormControl(null, [Validators.required, Validators.minLength(15), Validators.maxLength(16), Validators.pattern('^[0-9 ]*$')]),
      expMonth: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern('^[0-9]*$')]),
      expYear: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern('^[0-9]*$')]),
      verificationNumber: new FormControl(null, [Validators.required]),
      recurring: new FormControl(null)
    });
  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
    this.mainForm.get('recurring').setValue(true);
    this.mainForm.get('recurring').disable();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.registrationProfile.PaymentMethod) {
      this.mainForm.get('fullName').setValue(this.registrationProfile.PaymentMethod.NameOnAccount);
      this.mainForm.get('cc').setValue(this.registrationProfile.PaymentMethod.AccountNumber);
      this.mainForm.get('expMonth').setValue(this.registrationProfile.PaymentMethod.CCExpirationMonth);
      this.mainForm.get('expYear').setValue(this.registrationProfile.PaymentMethod.CCExpirationYear);
      this.mainForm.get('verificationNumber').setValue(this.registrationProfile.PaymentMethod.CVV);
      this.mainForm.get('recurring').setValue(this.registrationProfile.PaymentMethod.Recurring);
    }
    this.initData();
  }

  initData() {
    this.mainForm.valueChanges.subscribe(data => {
      this.registrationProfile.PaymentMethod = {} as PaymentMethodModel;
      this.registrationProfile.PaymentMethod.NameOnAccount = this.mainForm.get('fullName').value;
      this.registrationProfile.PaymentMethod.AccountNumber = this.mainForm.get('cc').value;
      this.registrationProfile.PaymentMethod.CCExpirationMonth = this.mainForm.get('expMonth').value;
      this.registrationProfile.PaymentMethod.CCExpirationYear = this.mainForm.get('expYear').value;
      this.registrationProfile.PaymentMethod.CVV = this.mainForm.get('verificationNumber').value;
      this.registrationProfile.PaymentMethod.MethodType = 'cc';
      this.registrationProfile.PaymentMethod.Recurring = this.mainForm.get('recurring').value;
      this.mainForm.get('cc').valueChanges.subscribe(dataUpdate => {
        dataUpdate = dataUpdate.replaceAll(' ', '');
        if (this.visaRegEx.test(dataUpdate)) {
          this.ccType = 'Visa';
        }
        if (this.mastercardRegEx.test(dataUpdate)) {
          this.ccType = 'Mastercard';
        }
        if (this.amexpRegEx.test(dataUpdate)) {
          this.ccType = 'amex';
        }
        if (this.discovRegEx.test(dataUpdate)) {
          this.ccType = 'Discover';
        }
      });
      this.updateData.emit(this.registrationProfile);
    });
  }

  goToNextPage() {
    this.next.emit();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return !(charCode < 96 && charCode > 106);
    }
    return true;
  }

  removeSpaces(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) || charCode === 190) {
      return !(charCode < 96 && charCode > 106);
    }
    return true;
  }
}
